import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css';

import ElementUI from 'element-ui';


// const api = 'http://goods2go.com.hk/goods2go-user/'
const api = 'https://www.noahsolutions.net/goods2go-user/'
Vue.config.productionTip = false
// 创建全局http请求对象
axios.defaults.baseURL= api

Vue.prototype.$http = axios
Vue.prototype.$baseURL = api

// 配置请求头
axios.interceptors.request.use(config =>{
  config.headers["X-User"] = window.sessionStorage.getItem('token')
  return config
})



Vue.use(ElementUI);

// 引入语言文件
import i18n from './language/index.js'

//引入swiper相关文件
import 'swiper/swiper-bundle.css'
import swiperSlide from "vue-awesome-swiper";
Vue.use(swiperSlide)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this
  }
}).$mount('#app')
